<template>
    <div
        class="thanks-banner"
        :style="`background-image: url(${ getPicture })`"
    >
        <div class="thanks-banner__content">
            <h1 class="thanks-banner__title">
                {{ messages.thanksForYourOrder }}
            </h1>
            <p class="thanks-banner__order">
                {{ messages.yourOrder }} №
                {{ result.order.number }}
                {{ messages.successfullyDone }}.
                <br>
                {{ messages.smsDetails }}
            </p>
            <p class="thanks-banner__text">
                {{ messages.track }}
                <DefLink :href="messages.cabinetLink">{{ messages.cabinet }}</DefLink>
            </p>
            <!--Privat bank-->
            <DefButtonPrimary
                v-if="payData && payData.psName === 'privatBank' && payData.buyLink"
                :href="payData.buyLink"
                target="_blank"
            >
                {{ messages.payBtn }}
            </DefButtonPrimary>
            <!--liqPay-->
            <DefLiqPayButton
                v-else-if="payData && payData.psName === 'liqPay'"
                :result="payData"
            />
        </div>
    </div>
</template>

<script>
import DefTitle from "../../def/DefTitle/DefTitle";
import DefLink from "../../def/DefLink/DefLink";
import DefButtonPrimary from "../../def/DefButtonPrimary/DefButtonPrimary";
import DefLiqPayButton from "../../def/DefLiqPayButton/DefLiqPayButton";
import DefImg from "../../def/DefImg/DefImg";

export default {
    name: 'ThanksBanner',
    props: ['result'],
    components: {
        DefTitle,
        DefLink,
        DefButtonPrimary,
        DefLiqPayButton,
        DefImg,
    },
    computed: {
        /**
         * payData будет пустой если заказ оплачен, @todo чекнуть
         * @returns {any}
         */
        payData() {
            const payData = this.result?.order?.payData || '{}';
            return JSON.parse(payData);
        },
        messages() {
            return this.result?.order?.messages
        },
        getPicture() {
            if (this.screenWidth >= 992) {
                return '/local/templates/love-you/images/thanks.png';
            } else if (this.screenWidth >= 768) {
                return '/local/templates/love-you/images/thanks-tablet.png';
            }
            return '/local/templates/love-you/images/thanks-mobile.png';
        }
    },
}
</script>

<style lang="scss" scoped>
.thanks-banner{
    margin-bottom: 4px;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    background-color: #fff;
    @include point-md{
        text-align: start;
    }
    &__content{
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 108px 16px;
        @include point-md{
            padding: 64px 24px;
        }
        @include point-lg{
            padding: 64px;
        }
        @include point-xl{
            max-width: 50%;
        }
    }
    &__title{
        font-weight: 500;
        font-size: 18px;
        line-height: 110%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #467496;
        margin-bottom: 16px;
        @include point-md{
            font-size: 24px;
        }
        @include point-lg{
            font-size: 32px;
        }
    }
    &__order{
        font-weight: 500;
        font-size: 16px;
        line-height: 110%;
        color: #363636;
        margin-bottom: 8px;
        @include point-md{
            font-size: 18px;
        }
    }
    &__text{
        font-weight: 400;
        font-size: 12px;
        line-height: 100%;
        @include point-md{
            font-size: 14px;
        }
    }

    :deep(.def-button-primary){
        margin-top: 16px;
        @include point-md{
            align-self: flex-start;
            min-width: 280px;
        }
    }
    :deep{
        .def-liq-pay-button{
            margin-top: 16px;
        }
    }
}
</style>